import "./Header.css";
import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";

function Header() {
  return (
    <header className="header">
      <a className="recruiter-skip" href="#main-content">Skip to content</a>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" fixed="top" aria-label="Main navigation">
        <Container>
          <Navbar.Brand href="#home">Dmitry Kordik</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end header__collapse">
            <Nav className="header__main-nav">
              <Nav.Link href="#portfolio">Projects</Nav.Link>
              <Nav.Link href="#experience">Experience</Nav.Link>
              <Nav.Link href="#about">Skills</Nav.Link>
              <Nav.Link href="#contact">Contact</Nav.Link>
            </Nav>
            <div className="header__app-links">
              <span className="header__app-label">My apps:</span>
              <a className="header__app-link" href="/tonearby">TONearby</a>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}
export default Header;
